export default __webpack_public_path__ + "static/media/design1.25ac8e17.png";